module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src500842655/src/html5-media-tool-angular/~/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module chunks = 2